import React from 'react';
import { Box } from '@mui/material';
import { AttachFile } from '@mui/icons-material';
import { useMsal, useAccount } from '@azure/msal-react';
import { SectionHeader, SectionPaper } from '../../../../common/components/styled-ui-elements';
import { DocumentUploadsControl } from '../../../../common/components/DocumentUploads';
import { useAppSelector } from '../../../../../app/hooks';
import {
  useListComplianceDocumentsQuery,
  useUploadComplianceDocumentMutation,
  useDownloadComplianceDocumentMutation,
  useDeleteComplianceDocumentMutation
} from '../../../../../services/ComplianceService/complianceApi';

/**
 * DocumentUploadsSection - thin Compliance-specific wrapper around the shared
 * DocumentUploadsControl. Wires compliance document hooks against #99's already-shipped document
 * endpoints (never modified here); only rendered on Edit, once a compliance item id exists.
 */
export const DocumentUploadsSection: React.FC = () => {
  const complianceItemId = useAppSelector(state => state.compliance.currentComplianceItem?.id) || '';

  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const currentUserName = account?.name || '';

  const { data: documents, isLoading, isError, error } = useListComplianceDocumentsQuery(complianceItemId, {
    skip: !complianceItemId
  });
  const [uploadComplianceDocument] = useUploadComplianceDocumentMutation();
  const [downloadComplianceDocument] = useDownloadComplianceDocumentMutation();
  const [deleteComplianceDocument] = useDeleteComplianceDocumentMutation();

  return (
    <Box>
      <SectionHeader
        icon={<AttachFile sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Documents"
      />
      <SectionPaper>
        <DocumentUploadsControl
          entityId={complianceItemId}
          documents={documents}
          isLoading={isLoading}
          isError={isError}
          error={error}
          currentUserName={currentUserName}
          defaultDocumentType="General"
          onUpload={(file, documentType) => uploadComplianceDocument({ complianceItemId, file, documentType }).unwrap().then(() => undefined)}
          onDownload={(documentId) => downloadComplianceDocument({ complianceItemId, documentId }).unwrap()}
          onDelete={(documentId) => deleteComplianceDocument({ complianceItemId, documentId }).unwrap()}
        />
      </SectionPaper>
    </Box>
  );
};

export default DocumentUploadsSection;
